import { fetchAuthSession } from 'aws-amplify/auth';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { API_URL, ApiResponse, genericServiceError, getHeaders } from '../lib/_api-helpers';

type UseDeleteRequestData = {
    deleteData: <U>() => Promise<ApiResponse<U>>;
    deleteInProgress: boolean;
};

export default function useDeleteRequest(endpoint: string): UseDeleteRequestData {
    const navigate = useNavigate();

    const url = `${API_URL}/${endpoint}`;

    const [deleteInProgress, setLoading] = React.useState(false);

    const deleteData = async <U>() => {
        setLoading(true);

        let token: string | undefined;

        try {
            const session = await fetchAuthSession();
            token = session.tokens?.accessToken?.toString();
            if (!token) {
                navigate('/signin');
                return genericServiceError<U>();
            }
        } catch {
            navigate('/signin');
            return genericServiceError<U>();
        }

        try {
            const headers = getHeaders(token);

            const response = await fetch(url, {
                headers,
                method: 'DELETE',
            });

            return await response.json();
        } catch (error) {
            return genericServiceError<U>();
        } finally {
            setLoading(false);
        }
    };

    return { deleteData, deleteInProgress };
}
